/**
 * Ruta a archivos bajo `public/`, respetando `base` de Vite (p. ej. despliegue en subcarpeta).
 */
export function publicAsset(pathFromPublicRoot: string): string {
  const base = import.meta.env.BASE_URL;
  const normalized = pathFromPublicRoot.startsWith('/') ? pathFromPublicRoot.slice(1) : pathFromPublicRoot;
  return `${base}${normalized}`.replace(/\/{2,}/g, '/');
}
